import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

type SectionHeaderProps = {
  title: string;
  selectionName?: string;
  className?: string;
};

export default function SectionHeader({
  title,
  selectionName,
  className,
}: SectionHeaderProps) {
  return (
    <h4 className={twMerge(clsx('hd-base flex gap-2 mb-2', className))}>
      <span>{title}</span>
      {selectionName && <span className="body-sm">{selectionName}</span>}
    </h4>
  );
}
